import React from "react";
import "../style/contact-us.css";
import emailIcon from "../assets/maillogo.svg";
import locationIcon from "../assets/locationlogo.svg";
import phoneIcon from "../assets/calllogo.svg";



import Map from "../components/map";

const Contact = () => {
    return (
        <div className="contact-section">

            {/* Contact Cards */}
            <div className="contact-container">
                <div className="container">
                    <div className="contact-je">
                        <div className="contact-card">
                            <img src={emailIcon} alt="Email" className="contact-icon" />
                            <p className="contact-label">EMAIL</p>
                            <p className="contact-infor">laxmishilaj@gmail.com</p>
                        </div>

                        <div className="contact-card">
                            <img src={locationIcon} alt="Location" className="contact-icon" />
                            <p className="contact-label">LOCATION</p>
                            <p className="contact-infor">CAPTOWN ENHANCE, SHILAJ, AHMEDABAD</p>
                        </div>

                        <div className="contact-card">
                            <img src={phoneIcon} alt="Phone" className="contact-icon" />
                            <p className="contact-label">CALL ANYTIME</p>
                            <p className="contact-infor">+91 84808 01010</p>
                        </div>
                    </div>
                </div>
            </div>


            {/* Contact Form */}
            <div className="contact-form-wrapper">
                <div className="container">
                    <div className="contact-form-je">
                        <p className="form-subtitle">JUST A CALL AWAY</p>
                        <h2 className="form-title">We'd Love To Hear From You!</h2>
                        <p className="form-desc">
                            We are here and always ready to help you. Let us know how we serve you and we’ll get back within no time.
                        </p>

                        <form className="contact-form">
                            <div className="form-row">
                                <input type="text" placeholder="Your Name" required />
                                <input type="text" placeholder="Last Name" required />
                            </div>

                            <div className="form-row">
                                <input type="text" placeholder="Phone Number" required />
                                <input type="email" placeholder="Your Email" required />
                            </div>

                            <textarea placeholder="Your Message" required></textarea>

                            <button type="submit" className="submit-btn">Send Message</button>
                        </form>
                    </div>
                </div>
            </div>


            {/* Google Map */}
            <div className="map-container">
                <div className="map-title">
                    <h3>Our Location</h3>
                </div>
                <div className="map">
                    <Map />
                </div>
            </div>

        </div>
    );
};

export default Contact;
